import { useEffect, useState } from "react";
import { getUserInfo, updateUserInfo } from "api/User";

export default function BankInfoTab() {
    const [bankAccountName, setBankAccountName] = useState("");
    const [bankAccountNumber, setBankAccountNumber] = useState("");
    const [bank, setBank] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getUserInfo().then(data => {
            if (data && data.info) {
                setBankAccountName(data.info.bank_account || "");
                setBankAccountNumber(data.info.bank_number || "");
                setBank(data.info.bank_name || "");
            }
        });
    }, []);

    const isValid =
        bankAccountName.trim() !== "" &&
        bankAccountNumber.trim() !== "" &&
        bank !== "";

    const handleUpdate = async () => {
        if (!isValid || loading) return;
        setLoading(true);
        try {
            await updateUserInfo({
                bank_account: bankAccountName,
                bank_number: bankAccountNumber,
                bank_name: bank,
            });
            alert("Cập nhật thông tin ngân hàng thành công!");
        } catch (error) {
            alert("Cập nhật thất bại, vui lòng thử lại sau.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="MuiTabPanel-root styles_tab_panel__NZzZm"
            role="tabpanel"
            aria-labelledby="mui-p-61391-T-4"
            id="mui-p-61391-P-4"
        >
            <form style={{ textAlign: "center", margin: "30px 0px" }}>
                {/* INFO BOX */}
                <div className="MuiBox-root css-pv4jdr">
                    <div className="MuiBox-root css-r4iezj">
                        <div className="MuiBox-root css-cau05o">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
                                <path
                                    fill="currentColor"
                                    d="M16.162 4.473C15.09 3.25 12.789 2.5 10 2.5s-5.09.75-6.162 1.973c-1.784 2.07-1.784 9 0 11.055C4.91 16.75 7.211 17.5 10 17.5s5.09-.75 6.162-1.973c1.784-2.07 1.784-8.984 0-11.054M10 6.063a.937.937 0 1 1 0 1.873.937.937 0 0 1 0-1.873m.75 8.062h-1.5a.75.75 0 1 1 0-1.5v-2.25a.75.75 0 1 1 0-1.5H10a.75.75 0 0 1 .75.75v3a.75.75 0 0 1 0 1.5"
                                />
                            </svg>
                        </div>
                        <div className="MuiBox-root css-13brihr">
                            Thông tin tài khoản này sẽ được sử dụng với mục đích hoàn tiền khi hoàn đơn
                            hoặc hoàn tiền chênh lệch. Giới hạn đổi: tối đa 3 lần/ngày.
                        </div>
                    </div>
                </div>

                {/* CHỦ TÀI KHOẢN */}
                <div className="MuiFormControl-root MuiTextField-root jss35">
                    <label
                        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled"
                        htmlFor="bankAccountName"
                    >
                        Chủ tài khoản (không dấu)
                        <span className="MuiFormLabel-asterisk MuiInputLabel-asterisk">
                            &thinsp;*
                        </span>
                    </label>

                    <div className="MuiInputBase-root MuiFilledInput-root jss20 MuiInputBase-formControl">
                        <input
                            id="bankAccountName"
                            placeholder="VI DU: NGUYEN VAN AN"
                            required
                            type="text"
                            className="MuiInputBase-input MuiFilledInput-input"
                            value={bankAccountName}
                            onChange={e => setBankAccountName(e.target.value.toUpperCase())}
                        />
                    </div>
                </div>

                {/* SỐ TÀI KHOẢN */}
                <div className="MuiFormControl-root MuiTextField-root jss35">
                    <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled">
                        Số tài khoản
                        <span className="MuiFormLabel-asterisk MuiInputLabel-asterisk">
                            &thinsp;*
                        </span>
                    </label>

                    <div className="MuiInputBase-root MuiFilledInput-root jss20 MuiInputBase-formControl">
                        <input
                            required
                            type="text"
                            className="MuiInputBase-input MuiFilledInput-input"
                            value={bankAccountNumber}
                            onChange={e =>
                                setBankAccountNumber(e.target.value.replace(/\D/g, ""))
                            }
                        />
                    </div>
                </div>

                {/* NGÂN HÀNG */}
                <div className="MuiFormControl-root MuiTextField-root jss35">
                    <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-filled">
                        Chọn ngân hàng
                        <span className="MuiFormLabel-asterisk MuiInputLabel-asterisk">
                            &thinsp;*
                        </span>
                    </label>
                    <div className="MuiInputBase-root MuiFilledInput-root none-arrow-select jss66 MuiInputBase-formControl">
                        <select
                            className="MuiSelect-root MuiSelect-select MuiSelect-filled MuiInputBase-input MuiFilledInput-input h-[60px]"
                            value={bank}
                            onChange={e => setBank(e.target.value)}
                        >
                            <option value="" disabled>--- Chọn ngân hàng ---</option>
                            <option value="VCB">Vietcombank</option>
                            <option value="ACB">ACB</option>
                            <option value="TCB">Techcombank</option>
                        </select>
                        <svg className="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconFilled" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M7 10l5 5 5-5z"></path>
                        </svg>
                    </div>
                </div>

                {/* BUTTON */}
                <div style={{ margin: "30px 0px" }}>
                    <button
                        className={`MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 bzqdaj my-order__button my-order__button--green ${isValid && !loading ? "" : "Mui-disabled Mui-disabled"
                            }`}
                        type="button"
                        disabled={!isValid || loading}
                        onClick={handleUpdate}
                    >
                        <span className="MuiButton-label">
                            {loading ? "Đang cập nhật..." : "Cập nhật"}
                        </span>
                    </button>
                </div>
            </form>
        </div>
    );
}
